export const resetStore = data => ({
  type: "RESET_STORE",
});
